import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling-light";
import { GovernPriority } from "owa-client-types/lib/GovernPriority";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "DiagnosticsDataCollection" */ "./lazyIndex"), { name: "DiagnosticsDataCollection", govern: GovernPriority.Default });

export const lazyRegisterDataCollectorIfNotRegistered: LazyAction<typeof lazyIndex.RegisterDataCollectorIfNotRegistered, typeof lazyModule> = new LazyAction(lazyModule, m => m.RegisterDataCollectorIfNotRegistered);

export const lazyRegisterReproDataCollectorIfNotRegistered: LazyAction<typeof lazyIndex.RegisterReproDataCollectorIfNotRegistered, typeof lazyModule> = new LazyAction(lazyModule, m => m.RegisterReproDataCollectorIfNotRegistered);

export type { DataCollectorSchema as DataCollector } from "./schema/DataCollectorSchema";
export type { ReproDataCollectorSchema as ReproDataCollector } from "./schema/ReproDataCollectorSchema";

export const lazyRegisterRecoveryAction: LazyAction<typeof lazyIndex.RegisterRecoveryAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.RegisterRecoveryAction);

export const lazyRunRecoveryAction: LazyAction<typeof lazyIndex.runRecoveryAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.runRecoveryAction);

export type { RecoveryActionSchema as RecoveryAction } from "./schema/RecoveryActionSchema";

export { default as getAvailableRecoveryActions } from "./getAvailableRecoveryActions";

export const lazyCreateODSFeedbackSession: LazyAction<typeof lazyIndex.createODSFeedbackSession, typeof lazyModule> = new LazyAction(lazyModule, m => m.createODSFeedbackSession);

export const lazyCompleteODSFeedbackSession: LazyAction<typeof lazyIndex.completeODSFeedbackSession, typeof lazyModule> = new LazyAction(lazyModule, m => m.completeODSFeedbackSession);

export const lazyCollectAndUploadData: LazyAction<typeof lazyIndex.CollectAndUploadData, typeof lazyModule> = new LazyAction(lazyModule, m => m.CollectAndUploadData);
